import { motion } from "framer-motion";

// Banda de texto en movimiento continuo (estilo kinetic / editorial).
export const Marquee = ({
  items,
  duration = 28,
  dark = true,
  testId = "marquee",
}) => {
  const loop = [...items, ...items];
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden py-5 md:py-7 ${
        dark ? "bg-[#0A0A0A] text-white" : "bg-white text-[#0A0A0A]"
      }`}
    >
      <motion.div
        className="flex w-max items-center"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration, ease: "linear", repeat: Infinity }}
      >
        {loop.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="mx-6 md:mx-10 text-2xl md:text-4xl font-black tracking-tight uppercase">
              {item}
            </span>
            <span className="text-[#E60000] text-2xl md:text-4xl">✱</span>
          </span>
        ))}
      </motion.div>
    </div>
  );
};

export default Marquee;
